import { render, staticRenderFns } from "./PhotoGalleryCategoryItem.vue?vue&type=template&id=24d5cc26&scoped=true&"
import script from "./PhotoGalleryCategoryItem.vue?vue&type=script&lang=js&"
export * from "./PhotoGalleryCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGalleryCategoryItem.vue?vue&type=style&index=0&id=24d5cc26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5cc26",
  null
  
)

export default component.exports